import { FileSignature, Inbox, MessagesSquare, PhoneCall } from "lucide-react";
import { ContactStep } from "@/lib/types";

// The four stages between hitting send and holding a plan. Contact-page only.
//
// `offsetDays` is in working days from the day the form is sent — the section
// resolves each one against the visitor's own calendar, so the promise reads as
// "Wednesday the 24th" rather than an abstract "within 24 hours".
export const contactSteps: ContactStep[] = [
  {
    number: "01",
    icon: Inbox,
    offsetDays: 0,
    eta: "The moment you send",
    title: "It lands with the makers",
    copy: "Your brief goes straight to the people who will design and build it. No ticket queue, no account manager rewriting your idea into someone else's words.",
  },
  {
    number: "02",
    icon: MessagesSquare,
    offsetDays: 1,
    eta: "Within one working day",
    title: "You get thinking back, not a template",
    copy: "The sharp questions, plus the first glimpse of how far this could actually go — usually a good deal further than the brief dared to ask for.",
  },
  {
    number: "03",
    icon: PhoneCall,
    offsetDays: 2,
    eta: "A 30-minute call",
    title: "We sharpen the ambition",
    copy: "Thirty minutes, and you walk away seeing your own idea more clearly than when you walked in. That is the bar we set for every first call.",
  },
  {
    number: "04",
    icon: FileSignature,
    offsetDays: 4,
    eta: "Inside a week",
    title: "A plan built to win",
    copy: "Scope, timeline and a fixed price — shaped around the version of this that outclasses everything already live in your market.",
  },
];

// How long each step stays selected before the section moves itself on.
export const CONTACT_STEP_INTERVAL = 4500;
